import * as axios from 'axios';

const BASE_URL = location.origin;

function upload(formData) {
    const url = `${BASE_URL}/file/upload`;

    return axios.post(url, formData)
        .then(x => {
            return `/file/${x.data}`;
        });
}

export { upload }



// WEBPACK FOOTER //
// ./resources/js/file-upload.service.js